import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { API_URL, IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

import type { IntercomTokenResponse } from '@/types/Intercom'

const fetchToken = async (
  accessToken: string | undefined | null,
): Promise<string> => {
  if (accessToken === null || accessToken === undefined) {
    throw new Error('No access token provided.')
  }
  const res: Response = await fetch(`${API_URL}/api/v1/intercom/token`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(res.statusText)
  }
  const res_json: IntercomTokenResponse = await res.json()
  return res_json.token
}

export const useIntercomToken = () => {
  const user = useAuthInfo()
  return useQuery({
    queryFn: () => fetchToken(user?.accessToken),
    queryKey: [user?.user?.userId, 'intercomToken'],
    enabled: !IS_FEDRAMP_ENVIRONMENT && user.isLoggedIn,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
}
